const OverviewIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 9.5 12 3l9 6.5V20a1 1 0 0 1-1 1h-5v-7H9v7H4a1 1 0 0 1-1-1z" />
  </svg>
);

const AppsIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="7" height="7" rx="1.5" />
    <rect x="14" y="3" width="7" height="7" rx="1.5" />
    <rect x="14" y="14" width="7" height="7" rx="1.5" />
    <rect x="3" y="14" width="7" height="7" rx="1.5" />
  </svg>
);

const LogoutIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
    <polyline points="16 17 21 12 16 7" />
    <line x1="21" y1="12" x2="9" y2="12" />
  </svg>
);

const CloseIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

const ThemeIcon = () => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="12" cy="12" r="4" />
    <path d="M12 2v2M12 20v2M4.93 4.93l1.42 1.42M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.42-1.42M17.66 6.34l1.41-1.41" />
  </svg>
);

const NAV_ITEMS = [
  { id: 'overview', label: 'Overview', icon: OverviewIcon },
  { id: 'apps', label: 'All Apps', icon: AppsIcon },
];

const THEME_OPTIONS = ['light', 'dark', 'system'];

export default function Sidebar({ activeTab, onTabChange, onLogout, theme, onThemeChange, menuOpen, onCloseMenu }) {
  return (
    <aside className="app-sidebar">
      <div className="app-sidebar-brand">
        <span className="app-sidebar-mark">C</span>
        <div className="app-sidebar-brand-text">
          <span className="app-sidebar-name">Commission</span>
          <span className="app-sidebar-tag">Dashboard</span>
        </div>
      </div>

      <nav className="app-sidebar-nav">
        {NAV_ITEMS.map(({ id, label, icon: Icon }) => (
          <button
            key={id}
            className={`app-sidebar-link ${activeTab === id ? 'active' : ''}`}
            onClick={() => onTabChange(id)}
          >
            <Icon />
            <span>{label}</span>
          </button>
        ))}
      </nav>

      <div className="app-sidebar-footer">
        <button className="app-sidebar-logout" onClick={onLogout}>
          <LogoutIcon />
          <span>Logout</span>
        </button>
      </div>

      <nav className="app-bottombar-nav">
        {NAV_ITEMS.map(({ id, label, icon: Icon }) => (
          <button
            key={id}
            className={`app-bottombar-link ${activeTab === id ? 'active' : ''}`}
            onClick={() => onTabChange(id)}
          >
            <Icon />
            <span>{label}</span>
          </button>
        ))}
      </nav>

      {menuOpen && (
        <div className="app-mobile-drawer-overlay" onClick={onCloseMenu}>
          <div className="app-mobile-drawer" onClick={(e) => e.stopPropagation()}>
            <div className="app-mobile-drawer-head">
              <span>Menu</span>
              <button className="app-mobile-drawer-close" onClick={onCloseMenu} aria-label="Close menu">
                <CloseIcon />
              </button>
            </div>


            <div className="app-mobile-drawer-section">
              <span className="app-mobile-drawer-label"><ThemeIcon /> Theme</span>
              <div className="app-mobile-drawer-theme">
                {THEME_OPTIONS.map((option) => (
                  <button
                    key={option}
                    className={`app-mobile-drawer-theme-btn ${theme === option ? 'active' : ''}`}
                    onClick={() => onThemeChange(option)}
                  >
                    {option.charAt(0).toUpperCase() + option.slice(1)}
                  </button>
                ))}
              </div>
            </div>

            <button className="app-sidebar-logout" onClick={onLogout}>
              <LogoutIcon />
              <span>Logout</span>
            </button>
          </div>
        </div>
      )}
    </aside>
  );
}
